import { create } from 'zustand'
import { debounce } from '../../utils/debounce'

type LayoutState = {
    isSidebarCollapsed: boolean
    toggleSidebar: () => void
    refreshSidebarState: () => void
    setSidebarCollapsed: (collapsed: boolean) => void
}

const isSmallScreen = () => window.matchMedia('(max-width: 1200px)').matches

const useLayoutStore = create<LayoutState>((set) => {
    const refreshSidebarState = () => {
        const currentState = isSmallScreen()
        set((state) => {
            // Only update the state if the value has changed
            if (state.isSidebarCollapsed !== currentState) {
                return { isSidebarCollapsed: currentState }
            }
            return {}
        })
    }

    // Debounce the refreshSidebarState function
    const debouncedRefreshSidebarState = debounce(refreshSidebarState, 200)

    // Set initial state
    set(() => ({ isSidebarCollapsed: isSmallScreen() }))

    // Register resize event listener
    window.addEventListener('resize', debouncedRefreshSidebarState)

    return {
        isSidebarCollapsed: isSmallScreen(),
        refreshSidebarState,
        toggleSidebar: () => {
            set((state) => ({ isSidebarCollapsed: !state.isSidebarCollapsed }))
        },
        setSidebarCollapsed: (collapsed) => {
            set({ isSidebarCollapsed: collapsed })
        },
    }
})

export default useLayoutStore
